import { WEB_BACKEND } from "./backends";

const BACKEND_URL = WEB_BACKEND;

export function normalizeImgUrl(url, fallback = "") {
  if (!url) return fallback;
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  if (url.startsWith("static/")) return `${BACKEND_URL}/api/${url}`;
  if (url.startsWith("/static/")) return `${BACKEND_URL}/api${url}`;
  return url;
}

export function normalizeHtmlContent(html) {
  if (!html) return "";
  // Fix relative image URLs to absolute backend URLs
  html = html.replace(/src="\/api\/static\/uploads\//g, `src="${BACKEND_URL}/api/static/uploads/`);
  // Strip inline styles — CSS (white-space: normal !important) handles wrapping for legacy content
  html = html.replace(/\s+style="[^"]*"/gi, "").replace(/\s+style='[^']*'/gi, "");
  return html;
}
